import { MenuProvider } from '../../../../../services/exports/Constants';

export default {
  form: {
    provider: {
      label: 'Proveedor de menú',
      options: {
        [null]: 'Seleccionar proveedor de menú',
        [MenuProvider.Lieferando]: 'Lieferando',
        [MenuProvider.Wolt]: 'Wolt',
        [MenuProvider.Deliveroo]: 'Deliveroo',
        [MenuProvider.UberEats]: 'Uber Eats',
        [MenuProvider.GloriaFood]: 'GloriaFood',
        [MenuProvider.Foodamigos]: 'Otro restaurante de Foodamigos',
        [MenuProvider.DoorDash]: 'DoorDash',
        [MenuProvider.Tabless]: 'Tabless (POS)',
        [MenuProvider.Thuisbezorgd]: 'Thuisbezorgd',
        [MenuProvider.TakeawayCom]: 'Takeaway.com',
        [MenuProvider.PysznePl]: 'Pyszne.pl',
        [MenuProvider.BistroSk]: 'Bistro.sk',
        [MenuProvider.JustEat]: 'Just Eat',
      },
    },
    provider_id: {
      [MenuProvider.Lieferando]: {
        label: 'URL de Lieferando',
        placeholder: 'URL del restaurante en Lieferando',
      },
      [MenuProvider.Wolt]: {
        label: 'URL de Wolt',
        placeholder: 'URL del restaurante en Wolt',
      },
      [MenuProvider.Deliveroo]: {
        label: 'Enlace de Deliveroo del restaurante',
        placeholder: 'https://deliveroo…/menu/city/area/restaurant',
        help: 'Abre tu restaurante en Deliveroo y copia el enlace de la barra de direcciones.',
        error:
          'Ingresa el enlace a la página del menú de un restaurante en Deliveroo. Tiene este formato: https://deliveroo.co.uk/menu/city/area/restaurant-name.',
      },
      [MenuProvider.UberEats]: {
        label: 'URL de Uber Eats',
        placeholder: 'URL del restaurante en Uber Eats',
      },
      [MenuProvider.GloriaFood]: {
        label: 'Enlace de GloriaFood',
        placeholder: 'https://www.foodbooking.com/ordering/restaurant/menu?restaurant_uid=…',
        help: {
          ordering_page: {
            title: 'Si usas la página de pedidos de GloriaFood:',
            description: 'Ingresa tu URL de pedidos de foodbooking.com.',
            example: 'https://www.foodbooking.com/ordering/restaurant/menu?restaurant_uid=…',
          },
          embedded_widget: {
            title: 'Si GloriaFood está integrado en tu propio sitio web:',
            description: 'Ingresa la URL de la página de tu sitio donde aparece el widget de pedidos.',
            example: 'https://yourrestaurant.com/order',
          },
        },
        error: 'Ingresa un enlace válido que comience con https://.',
        back_office_error:
          'Ese es un enlace del back office de GloriaFood, no la página desde la que piden tus clientes. Abre la página de pedidos de tu restaurante y pega ese enlace en su lugar.',
        wrong_platform_error:
          'Este no parece un enlace de GloriaFood. Si usas la página de pedidos alojada por GloriaFood, ingresa tu URL de pedidos de foodbooking.com. Si GloriaFood está integrado en tu propio sitio web, ingresa la URL de la página donde aparece tu widget de pedidos.',
      },
      [MenuProvider.Thuisbezorgd]: {
        label: 'URL de Thuisbezorgd',
        placeholder: 'URL del restaurante en Thuisbezorgd',
      },
      [MenuProvider.TakeawayCom]: {
        label: 'URL de Takeaway.com',
        placeholder: 'URL del restaurante en Takeaway.com',
      },
      [MenuProvider.PysznePl]: {
        label: 'URL de Pyszne.pl',
        placeholder: 'URL del restaurante en Pyszne.pl',
      },
      [MenuProvider.BistroSk]: {
        label: 'URL de Bistro.sk',
        placeholder: 'URL del restaurante en Bistro.sk',
      },
      [MenuProvider.JustEat]: {
        label: 'URL de Just Eat',
        placeholder: 'URL del restaurante en Just Eat',
      },
      [MenuProvider.DoorDash]: {
        label: 'Enlace de DoorDash del restaurante',
        placeholder: 'https://www.doordash.com/store/…',
        help: 'Abre tu restaurante en doordash.com y copia el enlace de la barra de direcciones.',
        error:
          'Ingresa el enlace a una página de restaurante de DoorDash. Empieza por https://www.doordash.com/store/.',
        store_number_error:
          'Este enlace solo contiene el número de la tienda. Abre el restaurante en doordash.com y copia el enlace con su nombre, por ejemplo https://www.doordash.com/store/restaurant-name-123456/.',
      },
      [MenuProvider.Foodamigos]: {
        label: 'Restaurante del que copiar el menú',
        placeholder: 'Seleccionar restaurante del que copiar el menú',
      },
    },
  },
};
